import { Component, OnInit } from '@angular/core';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';
import {
  ConfirmationModalComponent
} from '../../shared/components/confirmation-modal/confirmation-modal.component';

import { Entity, EntityValidationErrorResponse, Message } from '../../shared/models';

import { NotificationService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal/modal.service';
import { EntitiesService } from '../../shared/services';

@Component({
  selector: 'export-entity-data-modal',
  templateUrl: './export-entity-data-modal.component.html',
  styleUrls: ['./export-entity-data-modal.component.css']
})
export class ExportEntityDataModal extends ClosableModalWithErrorResponseModel<EntityValidationErrorResponse> implements OnInit {
  data: { entities: Entity[] };
  displayedEntities: Entity[];
  selectedEntityIDs: Number[] = [];
  allEntitiesSelected: Boolean = false;
  selectedFilterEntityName: string;
  isReversedOrder: Boolean = false;
  loadingSpinner: Boolean = false;
  generateExcelFailedError;
  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    protected entitiesService: EntitiesService
  ) {
    super(notificationService, modalService);
  }
  ngOnInit(): void {
    this.displayedEntities = this.data.entities.sort((entity1, entity2) => entity1.name.toUpperCase() > entity2.name.toUpperCase() ? 1 : -1).slice();
  }

  selectedEntityChange(entity: Entity): void {
    if (this.selectedEntityIDs.includes(entity.entityId)) {
      this.selectedEntityIDs = this.selectedEntityIDs.filter(entityID => entityID !== entity.entityId);
      entity.label = 'white';
    } else {
      this.selectedEntityIDs.push(entity.entityId);
      entity.label = '#FAF9FA';
    }
  }

  entitySelected(entity: Entity): Boolean {
    return this.selectedEntityIDs.includes(entity.entityId);
  }

  selectAllEntities(): void {
    if (this.selectedEntityIDs.length === this.data.entities.length) {
      this.selectedEntityIDs = [];
      this.allEntitiesSelected = false;
    } else {
      this.selectedEntityIDs = [];
      this.data.entities.forEach(entity => {
        this.selectedEntityIDs.push(entity.entityId);
      });
      this.allEntitiesSelected = true;
    }
  }

  download(): void {
    if (this.selectedEntityIDs.length === 0) {
      this.modalService.openModal({
        component: ConfirmationModalComponent,
        data: {
          title: 'Export Entity Data',
          content: 'You must select at least one entity to export.',
        } as Message
      });
    } else {
      const payloadData = { entityIds: this.selectedEntityIDs };
      this.loadingSpinner = true;
      this.entitiesService.generateAndDownloadEntitySofs(payloadData).subscribe(response => {
        this.loadingSpinner = false;
        const { data } = response;
        this.downloadFile(data);
        this.close();
      },
      error => {
        this.loadingSpinner = false;
        this.generateExcelFailedError = error;
        console.log(error);
      }
      );
    }
  }

  applyEntityFilter(): void {
    if (!this.selectedFilterEntityName) {
      this.displayedEntities = this.data.entities;
    } else {
      this.displayedEntities = this.data.entities.filter(entity => entity.name === this.selectedFilterEntityName);
    }
  }

  sortEntitiesOrder(): void {
    this.displayedEntities.sort((entity1, entity2) => entity1.name.toUpperCase() > entity2.name.toUpperCase() ? -1 : 1);
    this.isReversedOrder = true;
  }

  sortReverseEntitiesOrder(): void {
    this.displayedEntities.sort((entity1, entity2) => entity1.name.toUpperCase() > entity2.name.toUpperCase() ? 1 : -1);
    this.isReversedOrder = false;
  }

  downloadFile(signedUrl): void {
    window.open(signedUrl, '_self');
  }
}
